import { Component } from '@angular/core';

@Component({
  selector: 'app-asset-static-info',
  standalone: true,
  imports: [],
  host: {
    'class': 'fixed_status_bar'
  },
  templateUrl: './asset-static-info.component.html',
  styleUrl: './asset-static-info.component.scss'
})
export class AssetStaticInfoComponent {

}
